import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Profil } from '../../shared/model';
import { DatabaseConnection } from '../../shared/services/database-connection';

@Injectable({
  providedIn: 'root',
})
export class ProfilService {
  end_url = 'profil'

  constructor(private http : HttpClient, private  dbConnection : DatabaseConnection){}

  getAll(){
    return this.http.get<Profil[]>(this.dbConnection.remoteApiConnection.value + 'profil-liste')
  }

  create(data : FormData){
    return this.http.post<Profil>(this.dbConnection.remoteApiConnection.value + this.end_url, data)
  }

  update(data : FormData, id : string){
    return this.http.put<Profil>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id, data)
  }

  delete(id : string){
    return this.http.delete(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id)
  }

  changeRightState(id : string, right : string){
    return this.http.get<any>(this.dbConnection.remoteApiConnection.value + this.end_url + '/' + id + '/edit?right='+right)
  }

  changeRightStatesProfil(id : string, data : any){
    return this.http.post<any>(this.dbConnection.remoteApiConnection.value + 'change-rigths-state/'+id, data)
  }


}
